import { useEffect } from "react";
import { useState } from "react";
import CreatePlanAction from "../Section/CreatePlanAction";
import UpdatePlanAction from "../Section/UpdatePlanAction";
import PlanActionListItem from "./PlanActionListItem";
import { Popconfirm } from "antd";

export default function PlanAction(props) {
  let {
    plan = {},
    actionList = [],
    refresh = () => {},
    onDone = () => {},
    onClose = () => {},
    onBack = () => {},
    handleDiscord=()=>{},
    isEditable,
  } = props;
  const [planAction, setAction] = useState({});
  const pending_history = planAction.pending_history ? planAction.pending_history : {};
  const hasUpdated = Boolean(pending_history && pending_history.updated_data);
  const [history, setHistory] = useState(false);
  
  useEffect(() => {
    refresh();
  }, []);

  const ActionComponent = planAction.plan_action_id
    ? UpdatePlanAction
    : CreatePlanAction;
  return (
    <div className="row justify-content-center ">
      <div className="col-md-12">
        <div className="table-responsive border p-2">
          <table className="table questionnaire-table table-borderless mb-0">
            <thead>
              <tr className=" ">
                <td className="text-center">Plan Action Name</td>
                <td className="text-center">Plan Group</td>
                <td className="text-center">Action Type</td>
                <td className="text-center">Sort Order</td>
                <td className="text-center">Start Interval</td>
                <td className="text-center">Minimum Days</td>
                <td className="text-center">
                  Maximum Days
                </td>
                <td className="text-center">Action</td>
              </tr>
            </thead>
            <tbody>
              {actionList.length > 0 ? (
                actionList
                  .slice()
                  .filter((x)=>x?.active === true)
                  .sort((a, b) => a.sort_order - b.sort_order)
                  .map((item, i) => (
                    <PlanActionListItem
                      item={item}
                      key={i}
                      isEditable={isEditable}
                      onEdit={setAction}
                      {...props}
                      canDelete={!plan.published}
                      refresh={refresh}
                      reset={() => setAction({})}
                      setHistory={setHistory}
                    />
                  ))
              ) : (
                <tr>
                  <td className="text-center" colSpan="8">
                    No Plan Action Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {isEditable && (
        <ActionComponent
          {...props}
          planAction={planAction}
          setAction={setAction}
          reset={() => setAction({})}
        />
      )}
      <div className="d-flex align-items-end justify-content-center col-md-12 p-5">
      {isEditable && (hasUpdated || history) && (
          <Popconfirm
            title="Are you sure to discard and close?"
            onConfirm={handleDiscord}
            //  onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            <button
             type="button"
              className="btn btn-danger btn-sm float-right btn-add-domain mr-2"
            >
              Discard All & Close
            </button>
          </Popconfirm>
        )}
       <button
          onClick={onClose}
          type="button"
          className="btn btn-danger btn-sm float-right btn-add-domain mr-2"
        >
          Close
        </button>{" "}
        <button
          onClick={onBack}
          type="button"
          className="btn btn-error btn-sm float-right btn-add-domain mr-2"
        >
          Back
        </button>
        {actionList.length > 0 && (
          <button
            onClick={onDone}
            type="button"
            className="btn btn-secondary btn-sm float-right btn-add-domain mr-2"
          >
            Next
          </button>
        )}
      </div>
    </div>
  );
}
